<template>
    <span
        class="inline-block whitespace-nowrap rounded-md px-2 pt-1 pb-[2px] text-center align-baseline text-sm leading-none text-white"
        :class="{
            'bg-warning-500': type === MessageTypes.WARNING,
            'bg-danger-500': type === MessageTypes.ERROR,
            'bg-success-500': type === MessageTypes.SUCCESS,
            'bg-info-500': type === MessageTypes.INFO,
        }"
    >
        <slot></slot>
    </span>
</template>

<script setup lang="ts">
import { MessageTypes } from '@src/enums'

defineProps<{
    type: 'info' | 'warning' | 'error' | 'success' | 'error_while_generating'
}>()
</script>

<style scoped></style>
